import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IUploadedImageAsset } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  setDefaultSpaceAsset: {
    asset: IUploadedImageAsset
  }
}

const mutateHandler = handleFetchResult<IPayload, IUploadedImageAsset>({
  handler: (data) => data.setDefaultSpaceAsset.asset,
  name: 'Set Space Asset as default',
})

export default function setDefaultSpaceAssets(id: string): Promise<IUploadedImageAsset> {
  return client.gql
    .mutate({
      mutation,
      variables: { input: { id } },
    })
    .then(mutateHandler)
}

const mutation = gql`
  mutation setDefaultSpaceAsset($input: SetDefaultSpaceAssetInput!) {
    setDefaultSpaceAsset(input: $input) {
      asset {
        id
        url
        fileName
        updatedAt
        isDefault
      }
    }
  }
`
